import { Reveal, SectionLabel } from "@/components/site/bits";
import { motion } from "framer-motion";

const STEPS = [
  { t: "Discovery Call", d: "We understand your goals, challenges and vision." },
  { t: "Requirement Analysis", d: "Deep-dive into workflows, data and success metrics." },
  { t: "Strategy Design", d: "A tailored AI & automation blueprint for your business." },
  { t: "Development", d: "Agile builds with weekly demos and transparency." },
  { t: "Testing", d: "Rigorous QA across performance, security and UX." },
  { t: "Deployment", d: "Smooth go-live with zero-downtime rollouts." },
  { t: "Support", d: "Ongoing optimization, monitoring and scaling." },
];

export default function Process() {
  return (
    <section id="process" className="relative py-28 px-6" data-testid="process">
      <div className="mx-auto max-w-5xl">
        <Reveal>
          <SectionLabel>How We Work</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl font-bold tracking-tight">
            A proven path to <span className="text-gradient">launch</span>
          </h2>
        </Reveal>

        <div className="relative mt-14 pl-6">
          <div className="absolute left-0 top-2 bottom-2 w-px bg-gradient-to-b from-[#00E5FF] via-[#7B61FF] to-[#00FFB2]" />
          <div className="space-y-10">
            {STEPS.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.05}>
                <div className="relative pl-10" data-testid={`process-step-${i}`}>
                  <motion.span
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ type: "spring", stiffness: 260, damping: 18, delay: i * 0.05 }}
                    className="absolute -left-[26px] top-0 grid h-12 w-12 place-items-center rounded-full glass-strong font-display font-bold text-[#00E5FF]"
                  >
                    {String(i + 1).padStart(2, "0")}
                  </motion.span>
                  <h3 className="font-display text-xl font-semibold">{s.t}</h3>
                  <p className="mt-1 text-white/60">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
